import { DataServiceDivide } from './data-service-divide';
import { DataServiceMinus } from './data-service-minus';
import { DataServiceMultiply } from './data-service-multiply';
import { DataServiceOperator } from './data-service-operator.interface';
import { DataServicePlus } from './data-service-plus';

/**
 * Extensible interface for adding operators
 */
export class DataServiceOperatorTypeEnum {
	public static PLUS: string = 'plus';
	public static MINUS: string = 'minus';
	public static MULTIPLY: string = 'multiply';
	public static DIVIDE: string = 'divide';
}
/**
 * Converts string input to respective Operator.
 */
export class DataServiceOperatorBuilder {
	public static build(type: string): DataServiceOperator {
		switch (type) {
			case 'plus':
				return new DataServicePlus();
			case 'minus':
				return new DataServiceMinus();
			case 'multiply':
				return new DataServiceMultiply();
			case 'divide':
				return new DataServiceDivide();
			default:
				throw new Error('Operator not valid.');
		}
	}
}
